import React from "react";
import styles from "./Introduction.module.css";
import Anchor from "../Anchor/Anchor";

const Introduction = () => {
  return (
    <div className={styles.introduction}>
      <h1>ようこそ、StudioMKへ</h1>
      <p>大学生によるアプリ開発スタジオ</p>
      <p>
        "シンプルな操作でやりたいことを実現する"をモットーに洗練されたアプリを提供します。
      </p>
      <ul>
        <li className={styles.liAnchor}>
          <Anchor
            title="プライバシーポリシー"
            url="/privacypolicy"
            target="_self"
          />
        </li>
        <li className={styles.liAnchor}>
          <Anchor
            title="Instagram"
            url="https://www.instagram.com/studiomk.apps/"
            target="_blank"
          />
        </li>
      </ul>
    </div>
  );
};

export default Introduction;
